import React from 'react';

import { ProgressUpdateCard } from '../../../../blocks/ProgressUpdateCard';
import { Table } from '../../../../common/Table';
import { CheckInTypeEnum } from '../../../Check-In/types/types';
import {
  TCheckInDetails,
  TUserLevelCheckIns,
  useGetUserLevelCheckins,
} from '../../hooks/useGetUserLevelCheckins';
import { TeamOption } from '../../types/checkInQuality';

function CheckInQualityTable({
  selectedTeam,
}: {
  selectedTeam: TeamOption | null;
}): JSX.Element {
  const { userLevelCheckIns, isLoading, error } =
    useGetUserLevelCheckins(selectedTeam);

  return (
    <Table
      borderStyle="dashed"
      className="bg-white my-4"
      isLoading={isLoading}
      error={error}
      emptyStateMessage="No check-ins available for the selected team"
      columns={[
        {
          key: 'member',
          width: '25%',
          title: (
            <div className="h-full justify-center flex items-center">
              Team Member (Team)
            </div>
          ),
          borders: {
            right: true,
          },
          verticalAlign: 'top',
          render: (data: TUserLevelCheckIns) => {
            return (
              <div className="flex mx-2 gap-2">
                {data.userName} ({data.teamName})
              </div>
            );
          },
        },
        {
          key: 'update',
          title: <div className="h-full mx-4 flex items-center">Updates</div>,
          render: (data: TUserLevelCheckIns) => {
            return (
              <div className="flex flex-col gap-2">
                {data.checkins?.map((checkin: TCheckInDetails) => (
                  <ProgressUpdateCard
                    key={checkin?.checkin_id}
                    item={{
                      id: checkin?.ticket_checkin_id,
                      checkInId: checkin?.checkin_id,
                      type: checkin?.check_in_type as CheckInTypeEnum,
                      title: checkin?.title || '',
                      description: checkin?.description || '',
                      ticketId: checkin?.ticket_id || '',
                      blockers: checkin?.blockers || '',
                      wipLinks: checkin?.wipLinks || '',
                    }}
                    showDescription
                    hideMenu
                  />
                ))}
              </div>
            );
          },
        },
      ]}
      data={userLevelCheckIns}
    />
  );
}

export default CheckInQualityTable;
